<template>
  <div>
    <div :id="quickOrderLoadingElementId" style="display: none;" class='text-center'><div class='heading large-250'>Loading...</div><div class='loadingSpinner'></div></div>
    <div :id="quickOrderComponentId"></div>
  </div>
</template>

<script>
  export default {
    name: "QuickOrder",
    props: {
      barcode: String,
      templateId: Number,
      showQuickOrder: Boolean
    },
    data() {
      return {
        //quickOrderComponentId: "quickOrderComponent" + this.guidGenerator()
        prevBarcode: '',
        prevTemplateId: 0,
        isLoading: false,
      };
    },
    computed: {
      quickOrderComponentId: function () {
        return "quickOrderComponent" + this.guidGenerator()
      },
      quickOrderLoadingElementId: function () {
        return "quickOrderLoadingElementId" + this.guidGenerator()
      }
    },
    mounted() {
    },
    watch: {
      showQuickOrder: function (n, o) {
        if (n) {
          this.getQuickOrderHtmlContent();
        }
      },
    },
    methods: {
      getQuickOrderHtmlContent() {
        if (!this.barcode || this.barcode === '') return;
        if (!this.templateId || this.templateId <= 0) return;
        if (this.prevBarcode === this.barcode && this.prevTemplateId === this.templateId) return;

        this.prevBarcode = this.barcode;
        this.prevTemplateId = this.templateId;

        try {
          $.GetProductQuickOrderFormForContainer(this.barcode, this.templateId, "#" + this.quickOrderComponentId, "#" + this.quickOrderLoadingElementId);
        }
        catch (err) {
          console.log(err);
          //alert(err);
        }
      },
      guidGenerator() {
        var S4 = function () {
          return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// EcomCore/Components/Products/QuickOrder.vue